import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export function useCurrency() {
  const [currency, setCurrency] = useState('FCFA');

  useEffect(() => {
    console.log('Initialisation de l\'écoute de la devise...');
    
    const unsubscribe = onSnapshot(doc(db, 'settings', 'currency'), (doc) => {
      if (doc.exists()) {
        const currencyData = doc.data();
        console.log('Mise à jour de la devise:', currencyData);
        setCurrency(currencyData.code);
      } else {
        console.log('Document currency non trouvé, utilisation de la valeur par défaut');
      }
    }, (error) => {
      console.error('Erreur lors de l\'écoute de la devise:', error);
    });

    return () => unsubscribe();
  }, []);

  return currency;
} 